<template>
    <div class="">
        <template v-if="availableMasterPaletteSolid?.length > 0">
            <div class="mb-[16px] font-semibold text-[16px] font-oceanside" :class="{
                'text-red-error': hasErrorState,
            }">
                {{$t('COLOR_SOLID')}}
            </div>

            <div class="flex flex-wrap gap-[14px] overflow-y-auto pt-2 pb-3 px-2 -mx-[2px]">
                <master-palette-list
                    :list="availableMasterPaletteSolid"
                    :select-mode="selectMode"
                    :selected-color="selectedColor"
                    @handleUpdateColorIsSelected="handleUpdateColorIsSelected"
                />
            </div>
        </template>

        <template v-if="availableMasterPaletteTranslucent?.length > 0">
            <div class="mt-2 mb-[16px] font-semibold text-[16px] font-oceanside" :class="{
                'text-red-error': hasErrorState,
            }">
                {{$t('COLOR_TRANSLUCENT')}}
            </div>

            <div class="flex flex-wrap gap-[14px] overflow-y-auto pt-2 pb-3 px-2 -mx-[2px]">
                <master-palette-list
                    :list="availableMasterPaletteTranslucent"
                    :translucent="true"
                    :select-mode="selectMode"
                    :selected-color="selectedColor"
                    @handleUpdateColorIsSelected="handleUpdateColorIsSelected"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import MasterPaletteList from './MasterPaletteList.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            MasterPaletteList,
        },

        name: 'MasterPalette',

        props: {
            selectMode: {
                type: String,
                default: 'toggle',
                validator: (value) => ['toggle', 'checkmark'].includes(value),
            },
            selectedColor: {
                type: String,
                default: null,
            },
            hasErrorState: {
                type: Boolean,
                default: false,
            },
            limitBy: String,
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            masterPalette() {
                const palette = this.customizerStore?.masterPalette || [];

                if (this.allowedColors.size > 0) {
                    const filtered = [];

                    const allowed = this.allowedColors;

                    // eslint-disable-next-line no-restricted-syntax
                    for (const p of palette) {
                        if (p.id && allowed.has(p.id)) {
                            filtered.push(p);
                        }
                    }

                    return filtered;
                }

                return palette;
            },

            dedupedMasterPalette() {
                const seen = new Set();

                return this.masterPalette.filter((option) => {
                    const identity = option?.value || option?.color || option?.label;

                    if (!identity || seen.has(identity)) {
                        return false;
                    }

                    seen.add(identity);
                    return true;
                });
            },

            availableMasterPalette() {
                if (this.selectMode === 'checkmark') {
                    return this.dedupedMasterPalette;
                }

                return this.dedupedMasterPalette.filter((option) => !this.isOptionSelected(option));
            },

            availableMasterPaletteSolid() {
                return this.availableMasterPalette.filter((option) => !option.translucent);
            },

            availableMasterPaletteTranslucent() {
                return this.availableMasterPalette.filter((option) => option.translucent);
            },

            paletteSwatchSlots() {
                return this.customizerStore?.paletteSwatchSlots
                    || ['__empty__-0', '__empty__-1', '__empty__-2', '__empty__-3'];
            },

            allowedColors() {
                const allowed = new Set();

                if (this.limitBy) {
                    const placement = this.viewController.findPlacement(this.limitBy);
                    if (placement?.components) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const c of placement.components) {
                            if (c.placeholder) {
                                // eslint-disable-next-line no-continue
                                continue;
                            }

                            if (c.custom['v-id']) {
                                allowed.add(c.custom['v-id']);
                            }
                        }
                    }
                }

                return allowed;
            },
        },
        methods: {
            isSelectedInPaletteSlots(value) {
                if (!value) {
                    return false;
                }

                return this.paletteSwatchSlots.includes(value);
            },

            isOptionSelected(option) {
                if (!option) {
                    return false;
                }

                return !!option.selected || this.isSelectedInPaletteSlots(option.value);
            },

            handleUpdateColorIsSelected(option) {
                this.$emit('updateColorIsSelected', option);
            },
        },
    };
</script>
